import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import SiteLayout from "@/components/SiteLayout";
import AppLayout from "@/components/AppLayout";
import Home from "@/pages/site/Home";
import Pricing from "@/pages/site/Pricing";
import { ProductPage, SolutionsPage, DocsPage, LegalPage, AboutPage, ContactPage, StatusPage } from "@/pages/site/ContentPages";
import { LoginPage, RegisterPage, VerifyEmailPage, ForgotPage, ResetPage, MfaSetupPage } from "@/pages/AuthPages";
import Dashboard from "@/pages/portal/Dashboard";
import Devices from "@/pages/portal/Devices";
import DeviceDetail from "@/pages/portal/DeviceDetail";
import Enroll from "@/pages/portal/Enroll";
import Incidents from "@/pages/portal/Incidents";
import IncidentDetail from "@/pages/portal/IncidentDetail";
import Approvals from "@/pages/portal/Approvals";
import Automation from "@/pages/portal/Automation";
import Assistant from "@/pages/portal/Assistant";
import SettingsPage from "@/pages/portal/Settings";
import { Reports, Audit, MspClients } from "@/pages/portal/Misc";
import Billing from "@/pages/portal/Billing";
import { AdminDashboard, AdminOrgs, AdminPlans, AdminUsers, AdminAudit, AdminSystem } from "@/pages/admin/Admin";
import MasterDashboard from "@/pages/admin/MasterDashboard";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<SiteLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/product" element={<ProductPage />} />
              <Route path="/solutions/:slug" element={<SolutionsPage />} />
              <Route path="/solutions" element={<Navigate to="/solutions/small-business" replace />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/docs/:slug" element={<DocsPage />} />
              <Route path="/docs" element={<Navigate to="/docs/getting-started" replace />} />
              <Route path="/legal/:slug" element={<LegalPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/status" element={<StatusPage />} />
            </Route>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/verify-email" element={<VerifyEmailPage />} />
            <Route path="/forgot-password" element={<ForgotPage />} />
            <Route path="/reset-password" element={<ResetPage />} />
            <Route path="/mfa-setup" element={<MfaSetupPage />} />
            <Route path="/portal" element={<AppLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="devices" element={<Devices />} />
              <Route path="devices/:id" element={<DeviceDetail />} />
              <Route path="enroll" element={<Enroll />} />
              <Route path="incidents" element={<Incidents />} />
              <Route path="incidents/:id" element={<IncidentDetail />} />
              <Route path="approvals" element={<Approvals />} />
              <Route path="automation" element={<Automation />} />
              <Route path="assistant" element={<Assistant />} />
              <Route path="reports" element={<Reports />} />
              <Route path="audit" element={<Audit />} />
              <Route path="billing" element={<Billing />} />
              <Route path="settings" element={<SettingsPage />} />
              <Route path="clients" element={<MspClients />} />
            </Route>
            <Route path="/admin" element={<AppLayout admin />}>
              <Route index element={<AdminDashboard />} />
              <Route path="master" element={<MasterDashboard />} />
              <Route path="orgs" element={<AdminOrgs />} />
              <Route path="plans" element={<AdminPlans />} />
              <Route path="users" element={<AdminUsers />} />
              <Route path="audit" element={<AdminAudit />} />
              <Route path="system" element={<AdminSystem />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
